import * as types from '../actionTypes';

const initialState = {
  analyticalReview: [],
  loading: false,
  error: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ANALYTICAL_REVIEW_REQUEST:
      return {...state, loading: true, error: null};
    case types.FETCH_ANALYTICAL_REVIEW_SUCCESS:
      return {...state, loading: false, analyticalReview: action.analyticalReview, error: null};
    case types.FETCH_ANALYTICAL_REVIEW_FAILURE:
      return {...state, loading: false, error: action.error};
    default:
      return {...state};
  }
}

export default reducer;